import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-audio-published',
  templateUrl: './audio-published.component.html',
  styleUrls: ['./audio-published.component.scss']
})
export class AudioPublishedComponent implements OnInit {

  @Input() public bought;
  @Input() public message;
  @Input() public title;

  constructor(
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }
}
